import { editor } from "monaco-editor/esm/vs/editor/editor.api";
import { useEffect } from "react";
import { FocusMode, IAnnotationData, SelectionRange } from "../../../types";
import { AnnotationHandler } from "../../annotations/AnnotationHandler";
import { createBlurAnnotation, createDimmedAnnotation, createHighlightAnnotation } from "../../annotations/AnnotationTypes";

export const useEditorFocusMode = (codeEditor?: editor.ICodeEditor, filePath?: string, selection?: SelectionRange, readOnly?: boolean, focusMode?: FocusMode) => {

  useEffect(() => {
    if (!codeEditor || !filePath)
      return;

    codeEditor.updateOptions({
      readOnly: readOnly ?? false
    });

    if (filePath.endsWith(".md")) {
      codeEditor.updateOptions({
        wordWrap: "on"
      });
    } else {
      codeEditor.updateOptions({
        wordWrap: "off"
      });
    }

    if (selection) {
      codeEditor.revealRangeInCenter(selection, editor.ScrollType.Smooth);

      if (focusMode === undefined || focusMode === "selection")
        codeEditor.setSelection(selection);

      if (focusMode === "blurred" || focusMode === "dimmed") {
        const model = codeEditor.getModel();
        if (model) {
          const blurs: IAnnotationData[] = [];
          const annotationHandler = new AnnotationHandler(codeEditor);
          const lastLine = model.getLineCount();
          if (selection.endLineNumber + 1 < lastLine) {
            if (focusMode === "blurred")
              blurs.push(createBlurAnnotation(selection.endLineNumber + 1, lastLine));
            if (focusMode === "dimmed")
              blurs.push(createDimmedAnnotation(selection.endLineNumber + 1, lastLine));
          }
          if (selection.startLineNumber > 1) {
            if (focusMode === "blurred")
              blurs.push(createBlurAnnotation(1, selection.startLineNumber - 1));
            if (focusMode === "dimmed")
              blurs.push(createDimmedAnnotation(1, selection.startLineNumber - 1));
          }

          const highlightAnnotation = createHighlightAnnotation(selection.startLineNumber, selection.endLineNumber);
          const ids = annotationHandler.addAnnotations(filePath, [highlightAnnotation, ...blurs]);

          return () => {
            annotationHandler.removeAnnotations(ids);
          }
        }
      }
    }

  }, [codeEditor, filePath, selection, readOnly, focusMode])
}
